import { useFindRecord, usePopulate } from 'api/APIHooks';

export const useFindServiceAuthorization = (serviceAuthorizationId) => {
  const { data: serviceAuthorizationData, isSuccess: isSASuccess } = useFindRecord(
    'service_authorization',
    serviceAuthorizationId,
    { queryConfig: { placeholderData: undefined, enabled: !!serviceAuthorizationId } },
  );
  const serviceAuthorization = serviceAuthorizationData?.data?.data;

  const { isSuccess: isInsSuccess } = usePopulate(
    'insurance',
    'insurance',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );
  const { isSuccess: isPlanSuccess } = usePopulate(
    'insurance.plan',
    'plan',
    serviceAuthorization,
    { queryConfig: { placeholderData: undefined } },
  );

  return { serviceAuthorization, isSuccess: isSASuccess && isInsSuccess && isPlanSuccess };
};
